import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';

const footerSections = [
  {
    title: 'Suport',
    items: [
      { label: 'Termeni și Condiții', to: '/legal?tab=termeni' },
      { label: 'Politica Confidențialitate', to: '/legal?tab=confidentialitate' },
      { label: 'Cookies', to: '/legal?tab=cookies' }
    ]
  }
];

export default function Footer() {
  return (
    <footer className="bg-black text-white py-16 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex justify-center mb-6">
              <div className="relative">
                <img
                  src="/logo.png"
                  alt="VGL Logo"
                  className="w-16 h-16 object-contain"
                />
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full animate-pulse"></div>
              </div>
            </div>
            <p className="flex justify-center items-center text-gray-400 leading-relaxed mb-6">
  În siguranță, la timp, oriunde!
</p>

            <div className="flex justify-center space-x-4">
              <SocialLinks />
            </div>
          </div>

          {footerSections.map((section, index) => (
            <div key={index}>
              <h4 className="font-bold text-lg mb-6 text-white">{section.title}</h4>
              <ul className="space-y-3">
                {section.items.map((item, i) => (
                  <li key={i}>
                    <Link to={item.to} className="text-gray-400 hover:text-white transition">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 mb-4 md:mb-0">
              © 2025 VGL Trans Express. Toate drepturile rezervate.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <Link to="/legal?tab=confidentialitate">Politica de Confidențialitate</Link>
              <Link to="/legal?tab=termeni">Termeni și Condiții</Link>
              <Link to="/legal?tab=cookies">Cookies</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
